import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import { ServiceResponse, StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    MapperActivationState,
    PassiveMapperComp,
} from "userful-chronos-app-common-js/dist/models/mapping/MappingGroups";
import { SchedEventServiceResponse, SchedulableEvent } from "userful-chronos-app-common-js/dist/models/schedule/event";
import { SchedulableHeader, SchedulableID } from "userful-chronos-app-common-js/dist/models/schedule/schedulable";
import { Schedule } from "userful-chronos-app-common-js/dist/models/schedule/schedule";
import { eventsActions } from "../eventsSlice";
import { passiveMapperActions } from "../passiveMapperSlice";
import { schedulablesActions } from "../schedulablesSlice";
import scheduleStore from "../scheduleStore";
import {
    RESPONSE_CREATE_PASSIVE_MAPPER,
    RESPONSE_LIST_PASSIVE_MAPPERS,
    RESPONSE_MAPPER_STATE,
    RESPONSE_REMOVE_PASSIVE_MAPPER,
    RESPONSE_START_PASSIVE_MAPPER,
    RESPONSE_STOP_PASSIVE_MAPPER,
    RESPONSE_UPDATE_PASSIVE_MAPPER,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/mapping/MappingMsgDefinations";
import {
    NOTIFY_EVENT_CANCELLED,
    NOTIFY_EVENT_CREATED,
    NOTIFY_EVENT_REMOVED,
    NOTIFY_EVENT_SCHEDULED,
    NOTIFY_EVENT_UPDATED,
    NOTIFY_SCHEDULABLE_CREATED,
    NOTIFY_SCHEDULABLE_REMOVED,
    NOTIFY_SCHEDULABLE_UPDATED,
    NOTIFY_SCHEDULE_CREATED,
    NOTIFY_SCHEDULE_REMOVED,
    NOTIFY_SCHEDULE_UPDATED,
    RESPOND_LIST_SCHEDULABLES,
    RESPONSE_CANCEL_EVENT,
    RESPONSE_CREATE_AND_SCHEDULE_EVENT,
    RESPONSE_CREATE_EVENT,
    RESPONSE_CREATE_SCHEDULE,
    RESPONSE_LIST_EVENTS,
    RESPONSE_LIST_SCHEDULES,
    RESPONSE_REMOVE_EVENT,
    RESPONSE_REMOVE_SCHEDULE,
    RESPONSE_SCHEDULE_EVENT,
    RESPONSE_UPDATE_EVENT,
    RESPONSE_UPDATE_SCHEDULE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/schedule/scheduleMsgs";

let appID = null;
export const setAppIDForScheduleReceiver = (appIDValue: string) => {
    appID = appIDValue;
};

// Schedulable
registerMsgHandler(RESPOND_LIST_SCHEDULABLES, (payload) => {
    console.debug("RESPOND_LIST_SCHEDULABLES");
    const data = JSON.parse(payload) as SchedulableHeader[];
    scheduleStore.dispatch(schedulablesActions.setSchedulables(data));
});
registerMsgHandler(NOTIFY_SCHEDULABLE_CREATED, (payload) => {
    console.debug("NOTIFY_SCHEDULABLE_CREATED");
    const data = JSON.parse(payload) as SchedulableHeader;
    scheduleStore.dispatch(schedulablesActions.notifySchedulableAdded(data));
});
registerMsgHandler(NOTIFY_SCHEDULABLE_REMOVED, (payload) => {
    console.debug("NOTIFY_SCHEDULABLE_REMOVED");
    const data = JSON.parse(payload) as SchedulableID;
    scheduleStore.dispatch(schedulablesActions.notifySchedulableRemoved(data));
});
registerMsgHandler(NOTIFY_SCHEDULABLE_UPDATED, (payload) => {
    console.debug("NOTIFY_SCHEDULABLE_UPDATED");
    const data = JSON.parse(payload) as SchedulableHeader;
    scheduleStore.dispatch(schedulablesActions.notifySchedulableUpdated(data));
});

// Events
registerMsgHandler(RESPONSE_LIST_EVENTS, (payload) => {
    console.debug("RESPONSE_LIST_EVENTS");
    const data = JSON.parse(payload) as SchedulableEvent[];
    scheduleStore.dispatch(eventsActions.setEvents(data));
});
registerMsgHandler(RESPONSE_CREATE_EVENT, (payload) => {
    console.debug("RESPONSE_CREATE_EVENT");
    const data = JSON.parse(payload) as ServiceResponse;
});
registerMsgHandler(RESPONSE_UPDATE_EVENT, (payload) => {
    console.debug("RESPONSE_UPDATE_EVENT");
    const data = JSON.parse(payload) as ServiceResponse;
});
registerMsgHandler(RESPONSE_REMOVE_EVENT, (payload) => {
    console.debug("RESPONSE_REMOVE_EVENT");
    const data = JSON.parse(payload) as StringID;
    scheduleStore.dispatch(eventsActions.onRespondEventRemoved(data));
});
registerMsgHandler(RESPONSE_SCHEDULE_EVENT, (payload) => {
    console.debug("RESPONSE_SCHEDULE_EVENT");
    const data = JSON.parse(payload) as SchedEventServiceResponse;
});
registerMsgHandler(RESPONSE_CANCEL_EVENT, (payload) => {
    console.debug("RESPONSE_CANCEL_EVENT");
    const data = JSON.parse(payload) as ServiceResponse;
});
registerMsgHandler(RESPONSE_CREATE_AND_SCHEDULE_EVENT, (payload) => {
    console.debug("RESPONSE_CREATE_AND_SCHEDULE_EVENT");
    const data = JSON.parse(payload) as ServiceResponse;
});
registerMsgHandler(NOTIFY_EVENT_CREATED, (payload) => {
    console.debug("NOTIFY_EVENT_CREATED");
    const data = JSON.parse(payload) as SchedulableEvent;
    scheduleStore.dispatch(eventsActions.notifyEventAdded(data));
});
registerMsgHandler(NOTIFY_EVENT_UPDATED, (payload) => {
    console.debug("NOTIFY_EVENT_UPDATED");
    const data = JSON.parse(payload) as SchedulableEvent;
    scheduleStore.dispatch(eventsActions.notifyEventUpdated(data));
});
registerMsgHandler(NOTIFY_EVENT_REMOVED, (payload) => {
    console.debug("NOTIFY_EVENT_REMOVED");
    const data = JSON.parse(payload) as SchedulableEvent;
    scheduleStore.dispatch(eventsActions.notifyEventDeleted(data));
});
registerMsgHandler(NOTIFY_EVENT_SCHEDULED, (payload) => {
    console.debug("NOTIFY_EVENT_SCHEDULED");
    const data = JSON.parse(payload) as SchedulableEvent;
    scheduleStore.dispatch(eventsActions.notifyEventUpdated(data));
});
registerMsgHandler(NOTIFY_EVENT_CANCELLED, (payload) => {
    console.debug("NOTIFY_EVENT_CANCELLED");
    const data = JSON.parse(payload) as SchedulableEvent;
    scheduleStore.dispatch(eventsActions.notifyEventUpdated(data));
});

// Schedule
registerMsgHandler(RESPONSE_LIST_SCHEDULES, (payload) => {
    console.debug("RESPONSE_LIST_SCHEDULES");
    const data = JSON.parse(payload) as Schedule[];
    scheduleStore.dispatch(eventsActions.setSchedules(data));
});
registerMsgHandler(RESPONSE_CREATE_SCHEDULE, (payload) => {
    console.debug("RESPONSE_CREATE_SCHEDULE");
    const data = JSON.parse(payload) as ServiceResponse;
});
registerMsgHandler(RESPONSE_UPDATE_SCHEDULE, (payload) => {
    console.debug("RESPONSE_UPDATE_SCHEDULE");
    const data = JSON.parse(payload) as ServiceResponse;
});
registerMsgHandler(RESPONSE_REMOVE_SCHEDULE, (payload) => {
    console.debug("RESPONSE_REMOVE_SCHEDULE");
    const data = JSON.parse(payload) as ServiceResponse;
});
registerMsgHandler(NOTIFY_SCHEDULE_CREATED, (payload) => {
    console.debug("NOTIFY_SCHEDULE_CREATED");
    const data = JSON.parse(payload) as Schedule;
    scheduleStore.dispatch(eventsActions.notifyScheduleAdded(data));
});
registerMsgHandler(NOTIFY_SCHEDULE_UPDATED, (payload) => {
    console.debug("NOTIFY_SCHEDULE_UPDATED");
    const data = JSON.parse(payload) as Schedule;
    scheduleStore.dispatch(eventsActions.notifyScheduleUpdated(data));
});
registerMsgHandler(NOTIFY_SCHEDULE_REMOVED, (payload) => {
    console.debug("NOTIFY_SCHEDULE_REMOVED");
    const data = JSON.parse(payload) as Schedule;
    scheduleStore.dispatch(eventsActions.notifyScheduleDeleted(data));
});

// Passive Mapper
registerMsgHandler(RESPONSE_LIST_PASSIVE_MAPPERS, (payload) => {
    console.debug("RESPONSE_LIST_PASSIVE_MAPPERS");
    const data = JSON.parse(payload) as PassiveMapperComp[];
    scheduleStore.dispatch(passiveMapperActions.setMappers(data));
});
registerMsgHandler(RESPONSE_CREATE_PASSIVE_MAPPER, (payload) => {
    console.debug("RESPONSE_CREATE_PASSIVE_MAPPER");
    const data = JSON.parse(payload) as PassiveMapperComp;
    scheduleStore.dispatch(passiveMapperActions.notifyMapperAdded(data));
});
registerMsgHandler(RESPONSE_UPDATE_PASSIVE_MAPPER, (payload) => {
    console.debug("RESPONSE_UPDATE_PASSIVE_MAPPER");
    const data = JSON.parse(payload) as PassiveMapperComp;
    scheduleStore.dispatch(passiveMapperActions.notifyMapperUpdated(data));
});
registerMsgHandler(RESPONSE_REMOVE_PASSIVE_MAPPER, (payload) => {
    console.debug("RESPONSE_REMOVE_PASSIVE_MAPPER");
    const data = JSON.parse(payload) as StringID;
    scheduleStore.dispatch(passiveMapperActions.notifyMapperDeleted(data));
});
registerMsgHandler(RESPONSE_START_PASSIVE_MAPPER, (payload) => {
    console.debug("RESPONSE_START_PASSIVE_MAPPER");
    const data = JSON.parse(payload) as PassiveMapperComp;
});
registerMsgHandler(RESPONSE_STOP_PASSIVE_MAPPER, (payload) => {
    console.debug("RESPONSE_STOP_PASSIVE_MAPPER");
    const data = JSON.parse(payload) as StringID;
});
registerMsgHandler(RESPONSE_MAPPER_STATE, (payload) => {
    console.debug("RESPONSE_MAPPER_STATE");
    const data = JSON.parse(payload) as MapperActivationState;
});
